import { HoverCard as MantineHoverCard } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import { Body, Dropdown, Footer, Header } from "./info-card-components";
import { INFO_CARD_CLOSE_DELAY_MS, INFO_CARD_WIDTH } from "./info-card.constants";
import type { CustomInfoCardFactory, IProps } from "./info-card.types";

/**
 * A light hover card explaining the element it is attached to: an optional header, a bordered body and an optional
 * footer. Unlike HoverCard, which also styles chart tooltips, it has a single fixed appearance.
 */
const InfoCard = componentWrapper<CustomInfoCardFactory, IProps>("InfoCard", (props, _ref) => (
    <MantineHoverCard
        position="top"
        withArrow
        width={INFO_CARD_WIDTH}
        radius="lg"
        shadow="md"
        closeDelay={INFO_CARD_CLOSE_DELAY_MS}
        transitionProps={{ duration: 0 }}
        {...props}
    />
));

InfoCard.Target = MantineHoverCard.Target;
InfoCard.Dropdown = Dropdown;
InfoCard.Header = Header;
InfoCard.Body = Body;
InfoCard.Footer = Footer;

export { InfoCard };
